module.exports = __webpack_public_path__ + "img/pub2.5bcf247c.png";